import WidgetsBanner from './WidgetsBanner';

export default WidgetsBanner;
